<template>
  <div class="name">
    <div class="uk-position-center" v-if="!foundReport" >
      <div uk-spinner></div>
    </div>
    <div class="uk-container uk-container-large uk-margin-large-top " v-if="foundReport">
      <nav class="uk-navbar-container uk-navbar-transparent" uk-navbar>
          <div class="uk-navbar-left">
            <h3 class="uk-margin-remove uk-text-middle uk-text-capitalize">
              <router-link :to="'/'">
                <span class="backBtn" uk-icon="icon: arrow-left; ratio: 1.7"></span>
              </router-link>{{ hotel.name }}
            </h3>
          </div>
          <div class="uk-navbar-right">
            <date-range-picker
              :opens="opens"
              :startDate="startDate" 
              :endDate="endDate" 
              @update="updateValues"
              />
          </div>
      </nav>
      <div class="uk-text-center uk-margin-medium-top" uk-grid>
        <div class="uk-width-1-4">
          <div class="uk-card uk-card-default">
            <div class="uk-card-body uk-padding-small">
              <div class="uk-countdown-number"> {{reports.visitCount}} </div>
              <div class="uk-countdown-label uk-margin-top uk-text-center">clicks</div>
            </div>
            <div class="uk-card-footer uk-padding-remove">
              <div class="box-footer uk-text-meta">Overview</div>
            </div>
          </div>
        </div>
        <div class="uk-width-3-4">
            <div class="uk-card uk-card-default uk-card-body" v-if="chartData">
              <area-chart :data="chartData" :download="true"></area-chart>
            </div>
        </div>
      </div>
      <!-- <div class="uk-position-center uk-text-center uk-overlay" v-if="noReport">
          <span uk-icon="icon: database; ratio: 4"></span>
          <p class="uk-text-uppercase uk-margin-remove">no records</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as moment from "moment";
import Nav from "@/components/nav";
import { api } from "@/helpers/config";
import DateRangePicker from "vue2-daterange-picker/src/lib";

export default {
  name: "about",
  data: () => ({
    reports: [],
    foundReport: false,
    opens: "left",
    startDate: "2018-06-20",
    endDate: "2018-06-19",
    chartData: {},
    hotel:{}
  }),
  components: {
    "top-menu": Nav,
    DateRangePicker
  },
  created() {
    this._getReport();
  },
  methods: {
    updateValues(values) {
      this.startDate = values.startDate.toISOString().slice(0, 10);
      this.endDate = values.endDate.toISOString().slice(0, 10);
      axios
        .post(api.filter, {
          hotelId: this.$route.params.hotelId,
          startDate: this.startDate,
          endDate: this.endDate
        })
        .then(response => {
          this.reports = response.data.reports;
          var analytics = response.data.reports.analytics;
          // if (analytics.length < 7) {
          var result = [];
          for (var i = 0; i < 6; i++) {
            var d = moment();
            let date = moment(d)
              .subtract(i, "days")
              .format("YYYY-MM-DD");
            this.chartData[date] = 0;
          }
          // }
          analytics.forEach(element => {
            this.chartData[element.date] = element.visiterCount;
          });

          this.foundReport = true

        });
    },
    _getReport() {
      axios.get(api.analytics + this.$route.params.hotelId).then(response => {
        this.reports = response.data.reports;
        this.hotel = response.data.reports.hotel
        var analytics = response.data.reports.analytics;
        // if (analytics.length < 7) {
        var result = [];
        for (var i = 0; i < 6; i++) {
          var d = moment();
          let date = moment(d)
            .subtract(i, "days")
            .format("YYYY-MM-DD");
          this.chartData[date] = 0;
        }
        // }
        analytics.forEach(element => {
          this.chartData[element.date] = element.visiterCount;
        });
        this.foundReport = true
      });
    }
  }
};
</script>

